// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppHeader_header-container__b8F9H {
  min-height: 55px;
  height: 70px;
  max-height: 70px;
  background-color: var(--m-header-background-color);
  display: flex;
  align-items: center;
  padding: 0 20px;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 11;
  box-shadow: var(--m-header-box-shadow);
}
.AppHeader_header-container--border-bottom__RoMX6 {
  border-bottom: 1px solid var(--m-border-color);
  box-shadow: unset;
}
.AppHeader_header-container__desktop__Xq21w {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  width: 100%;
  position: relative;
}
.AppHeader_header-container__desktop__Xq21w svg {
  font-size: 20px;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_user-greeting__5fMDE {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-left: 24px;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_user-greeting__avatar__GXrs2 {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid var(--m-border-color);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_user-greeting__avatar__GXrs2 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_user-greeting__info__aRivw {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_user-greeting__info--top__ipiRe {
  display: flex;
  align-items: center;
  gap: 6px;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_user-greeting__info--welcome__jjhX2 {
  font-size: 14px;
  color: var(--m-text-light);
  line-height: 1.2;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_user-greeting__info--name__q9\\+ak {
  font-size: 14px;
  font-weight: 600;
  color: var(--m-text-color);
  line-height: 1.2;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_user-greeting__info--email__cLYCW {
  font-size: 12px;
  color: var(--m-primary);
  opacity: 0.85;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_header-center__OScQ- {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 12px;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_header-center__badge__ElzmU {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background-color: var(--m-content-background);
  border: 1px solid var(--m-border-color);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: var(--m-text-color);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
  white-space: nowrap;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_header-center__badge--icon__0GgDb {
  font-size: 14px !important;
  color: var(--m-primary) !important;
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_header-center__badge__ElzmU:hover {
  background-color: var(--m-primary);
  color: #fff;
  border-color: var(--m-primary);
}
.AppHeader_header-container__desktop__Xq21w .AppHeader_header-center__badge__ElzmU:hover .AppHeader_header-center__badge--icon__0GgDb {
  color: #fff !important;
}
.AppHeader_header-container__desktop--options__0rdQ8 {
  display: flex;
  align-items: center;
  gap: 16px;
}
.AppHeader_header-container__desktop--options__0rdQ8 .AppHeader_header-fx-notify-cluster__tJpra {
  display: flex;
  align-items: center;
  gap: 16px;
}
.AppHeader_header-container__desktop--options__0rdQ8 .AppHeader_header-options-divider__-c4FG {
  width: 1px;
  height: 28px;
  background-color: var(--m-border-color);
  flex-shrink: 0;
}
.AppHeader_header-container__desktop--options__0rdQ8 .AppHeader_action-icon__Q2MtW {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.AppHeader_header-container__desktop--options__0rdQ8 .AppHeader_action-icon__Q2MtW svg {
  font-size: 20px;
  color: var(--m-icon-color);
}
.AppHeader_header-container__desktop--options__0rdQ8 .AppHeader_action-icon__Q2MtW:hover svg {
  color: var(--m-primary);
}
.AppHeader_header-container__mobile__CgY1O {
  display: none;
  width: 100%;
}
.AppHeader_header-container__mobile__CgY1O svg {
  font-size: 20px;
  color: var(--m-icon-color);
}
.AppHeader_header-container__mobile__CgY1O .AppHeader_header-mobile__items__\\+T8LK {
  display: flex;
  align-items: center;
  gap: 16px;
}
.AppHeader_header-container__mobile__CgY1O .AppHeader_header-mobile__items__\\+T8LK .AppHeader_header-options-divider__-c4FG {
  width: 1px;
  height: 24px;
  background-color: var(--m-border-color);
  flex-shrink: 0;
}
@media (max-width: 480px) {
  .AppHeader_header-container__mobile__CgY1O .AppHeader_header-mobile__items__\\+T8LK {
    gap: 10px;
  }
}
.AppHeader_header-container__mobile__CgY1O .AppHeader_header-mobile__items--icon__rWmvc {
  font-size: 20px;
}
.AppHeader_header-container__mobile__CgY1O .AppHeader_header-mobile__items--search__V2aNm {
  background-color: var(--m-sidebar-background-color);
  box-shadow: var(--m-dropdown-shadow);
  border-radius: var(--m-border-radius);
  width: 90%;
  padding: 12px;
  position: fixed;
  left: 0;
  right: 0;
  top: 70px;
  margin: 0 auto;
  border: 1px solid transparent;
}
.AppHeader_header-container__mobile__CgY1O .AppHeader_header-mobile__items--search--input__v4Gcl {
  display: block;
  width: 100%;
  padding: 0.45rem 0.9rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 23px;
  color: var(--m-text-light);
  background-color: transparent;
  border: 1px solid var(--m-border-color);
  border-radius: var(--m-border-radius);
  outline: none;
}
.AppHeader_header-container__b8F9H .AppHeader_header-brand-navigation__\\+CCHd {
  display: flex;
  align-items: stretch;
  align-self: stretch;
  min-width: 0;
}
.AppHeader_header-container__b8F9H .AppHeader_header-logo__Q207U {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding-right: 20px;
  border-right: 1px solid var(--m-border-color);
}
.AppHeader_header-container__b8F9H .AppHeader_header-logo__Q207U img {
  display: block;
  width: 132px;
  max-height: 40px;
  object-fit: contain;
}
.AppHeader_header-container__b8F9H .AppHeader_mobile-brand__veTbd {
  display: flex;
  align-items: center;
  gap: 14px;
}
.AppHeader_header-container__b8F9H .AppHeader_mobile-brand__veTbd img {
  display: block;
  width: 104px;
  max-height: 36px;
  object-fit: contain;
}

[m-data-theme=dark] .AppHeader_header-container--border-bottom__RoMX6,
[m-data-top-menu-theme=dark] .AppHeader_header-container--border-bottom__RoMX6 {
  border-color: #5d6b83;
  box-shadow: unset;
}
@keyframes AppHeader_rotation__\\+zgNE {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* Small devices (landscape phones, 576px and up) */
@media (max-width: 1199.88px) {
  .AppHeader_header-container__b8F9H {
    z-index: 22;
  }
  .AppHeader_header-container__desktop__Xq21w {
    display: none;
  }
  .AppHeader_header-container__mobile__CgY1O {
    display: block;
  }
}
@media (max-width: 575.88px) {
  .AppHeader_header-container__b8F9H {
    height: 62px;
    padding: 0 14px;
  }
  .AppHeader_header-container__b8F9H .AppHeader_mobile-brand__veTbd img {
    width: 88px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/AppHeader/AppHeader.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kDAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EAEA,gBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,sCAAA;AACF;AACE;EACE,8CAAA;EACA,iBAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAAJ;AAEI;EACE,eAAA;AAAN;AAGI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AADN;AAGM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,0CAAA;AADR;AAGQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AADV;AAKM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAHR;AAKQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAHV;AAMQ;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;AAJV;AAOQ;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AALV;AAQQ;EACE,eAAA;EACA,uBAAA;EACA,aAAA;AANV;AAWI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AATN;AAWM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6CAAA;EACA,uCAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,yCAAA;EACA,yBAAA;EACA,mBAAA;AATR;AAWQ;EACE,0BAAA;EACA,kCAAA;AATV;AAYQ;EACE,kCAAA;EACA,WAAA;EACA,8BAAA;AAVV;AAYU;EACE,sBAAA;AAVZ;AAgBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAdN;AAgBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAdR;AAiBM;EACE,UAAA;EACA,YAAA;EACA,uCAAA;EACA,cAAA;AAfR;AAkBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AAhBR;AAkBQ;EACE,eAAA;EACA,0BAAA;AAhBV;AAoBU;EACE,uBAAA;AAlBZ;AAyBE;EACE,aAAA;EACA,WAAA;AAvBJ;AAyBI;EACE,eAAA;EACA,0BAAA;AAvBN;AA2BM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAzBR;AA2BQ;EACE,UAAA;EACA,YAAA;EACA,uCAAA;EACA,cAAA;AAzBV;AA4BQ;EAZF;IAaI,SAAA;EAzBR;AACF;AA2BQ;EACE,eAAA;AAzBV;AA4BQ;EACE,mDAAA;EACA,oCAAA;EACA,qCAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,6BAAA;AA1BV;AA4BU;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,6BAAA;EACA,uCAAA;EACA,qCAAA;EACA,aAAA;AA1BZ;AAiCE;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;AA/BJ;AAkCE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,6CAAA;AAhCJ;AAkCI;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAhCN;AAoCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAlCJ;AAoCI;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAlCN;;AA0CI;;EACE,qBAAA;EACA,iBAAA;AAtCN;AAoDA;EACE;IACE,uBAAA;EAzCF;EA2CA;IACE,yBAAA;EAzCF;AACF;AA4CA,mDAAA;AACA;EACE;IACE,WAAA;EA1CF;EA4CE;IACE,aAAA;EA1CJ;EA6CE;IACE,cAAA;EA3CJ;AACF;AA+CA;EACE;IACE,YAAA;IACA,eAAA;EA7CF;EA+CE;IACE,WAAA;EA7CJ;AACF","sourcesContent":[".header-container {\n  min-height: 55px;\n  height: 70px;\n  max-height: 70px;\n  background-color: var(--m-header-background-color);\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 11;\n  box-shadow: var(--m-header-box-shadow);\n\n  &--border-bottom {\n    border-bottom: 1px solid var(--m-border-color);\n    box-shadow: unset;\n  }\n\n  &__desktop {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    align-self: stretch;\n    width: 100%;\n    position: relative;\n\n    svg {\n      font-size: 20px;\n    }\n\n    .user-greeting {\n      display: flex;\n      align-items: center;\n      gap: 14px;\n      margin-left: 24px;\n\n      &__avatar {\n        width: 44px;\n        height: 44px;\n        border-radius: 50%;\n        overflow: hidden;\n        border: 2px solid var(--m-border-color);\n        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n\n      &__info {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        gap: 2px;\n\n        &--top {\n          display: flex;\n          align-items: center;\n          gap: 6px;\n        }\n\n        &--welcome {\n          font-size: 14px;\n          color: var(--m-text-light);\n          line-height: 1.2;\n        }\n\n        &--name {\n          font-size: 14px;\n          font-weight: 600;\n          color: var(--m-text-color);\n          line-height: 1.2;\n        }\n\n        &--email {\n          font-size: 12px;\n          color: var(--m-primary);\n          opacity: 0.85;\n        }\n      }\n    }\n\n    .header-center {\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      display: flex;\n      align-items: center;\n      gap: 12px;\n\n      &__badge {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        padding: 6px 14px;\n        background-color: var(--m-content-background);\n        border: 1px solid var(--m-border-color);\n        border-radius: 20px;\n        font-size: 12px;\n        font-weight: 500;\n        color: var(--m-text-color);\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);\n        transition: all 0.2s ease;\n        white-space: nowrap;\n\n        &--icon {\n          font-size: 14px !important;\n          color: var(--m-primary) !important;\n        }\n\n        &:hover {\n          background-color: var(--m-primary);\n          color: #fff;\n          border-color: var(--m-primary);\n\n          .header-center__badge--icon {\n            color: #fff !important;\n          }\n        }\n      }\n    }\n\n    &--options {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n\n      .header-fx-notify-cluster {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n      }\n\n      .header-options-divider {\n        width: 1px;\n        height: 28px;\n        background-color: var(--m-border-color);\n        flex-shrink: 0;\n      }\n\n      .action-icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 4px;\n        border: 0;\n        background: transparent;\n        cursor: pointer;\n\n        svg {\n          font-size: 20px;\n          color: var(--m-icon-color);\n        }\n\n        &:hover {\n          svg {\n            color: var(--m-primary);\n          }\n        }\n      }\n    }\n  }\n\n  &__mobile {\n    display: none;\n    width: 100%;\n\n    svg {\n      font-size: 20px;\n      color: var(--m-icon-color);\n    }\n\n    .header-mobile {\n      &__items {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n\n        .header-options-divider {\n          width: 1px;\n          height: 24px;\n          background-color: var(--m-border-color);\n          flex-shrink: 0;\n        }\n\n        @media (max-width: 480px) {\n          gap: 10px;\n        }\n\n        &--icon {\n          font-size: 20px;\n        }\n\n        &--search {\n          background-color: var(--m-sidebar-background-color);\n          box-shadow: var(--m-dropdown-shadow);\n          border-radius: var(--m-border-radius);\n          width: 90%;\n          padding: 12px;\n          position: fixed;\n          left: 0;\n          right: 0;\n          top: 70px;\n          margin: 0 auto;\n          border: 1px solid transparent;\n\n          &--input {\n            display: block;\n            width: 100%;\n            padding: 0.45rem 0.9rem;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 23px;\n            color: var(--m-text-light);\n            background-color: transparent;\n            border: 1px solid var(--m-border-color);\n            border-radius: var(--m-border-radius);\n            outline: none;\n          }\n        }\n      }\n    }\n  }\n\n  .header-brand-navigation {\n    display: flex;\n    align-items: stretch;\n    align-self: stretch;\n    min-width: 0;\n  }\n\n  .header-logo {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    padding-right: 20px;\n    border-right: 1px solid var(--m-border-color);\n\n    img {\n      display: block;\n      width: 132px;\n      max-height: 40px;\n      object-fit: contain;\n    }\n  }\n\n  .mobile-brand {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n\n    img {\n      display: block;\n      width: 104px;\n      max-height: 36px;\n      object-fit: contain;\n    }\n  }\n}\n\n[m-data-theme=\"dark\"],\n[m-data-top-menu-theme=\"dark\"] {\n  .header-container {\n    &--border-bottom {\n      border-color: #5d6b83;\n      box-shadow: unset;\n    }\n  }\n}\n\n@-webkit-keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Small devices (landscape phones, 576px and up) */\n@media (max-width: 1199.88px) {\n  .header-container {\n    z-index: 22;\n\n    &__desktop {\n      display: none;\n    }\n\n    &__mobile {\n      display: block;\n    }\n  }\n}\n\n@media (max-width: 575.88px) {\n  .header-container {\n    height: 62px;\n    padding: 0 14px;\n\n    .mobile-brand img {\n      width: 88px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header-container": `AppHeader_header-container__b8F9H`,
	"header-container--border-bottom": `AppHeader_header-container--border-bottom__RoMX6`,
	"header-container__desktop": `AppHeader_header-container__desktop__Xq21w`,
	"user-greeting": `AppHeader_user-greeting__5fMDE`,
	"user-greeting__avatar": `AppHeader_user-greeting__avatar__GXrs2`,
	"user-greeting__info": `AppHeader_user-greeting__info__aRivw`,
	"user-greeting__info--top": `AppHeader_user-greeting__info--top__ipiRe`,
	"user-greeting__info--welcome": `AppHeader_user-greeting__info--welcome__jjhX2`,
	"user-greeting__info--name": `AppHeader_user-greeting__info--name__q9+ak`,
	"user-greeting__info--email": `AppHeader_user-greeting__info--email__cLYCW`,
	"header-center": `AppHeader_header-center__OScQ-`,
	"header-center__badge": `AppHeader_header-center__badge__ElzmU`,
	"header-center__badge--icon": `AppHeader_header-center__badge--icon__0GgDb`,
	"header-container__desktop--options": `AppHeader_header-container__desktop--options__0rdQ8`,
	"header-fx-notify-cluster": `AppHeader_header-fx-notify-cluster__tJpra`,
	"header-options-divider": `AppHeader_header-options-divider__-c4FG`,
	"action-icon": `AppHeader_action-icon__Q2MtW`,
	"header-container__mobile": `AppHeader_header-container__mobile__CgY1O`,
	"header-mobile__items": `AppHeader_header-mobile__items__+T8LK`,
	"header-mobile__items--icon": `AppHeader_header-mobile__items--icon__rWmvc`,
	"header-mobile__items--search": `AppHeader_header-mobile__items--search__V2aNm`,
	"header-mobile__items--search--input": `AppHeader_header-mobile__items--search--input__v4Gcl`,
	"header-brand-navigation": `AppHeader_header-brand-navigation__+CCHd`,
	"header-logo": `AppHeader_header-logo__Q207U`,
	"mobile-brand": `AppHeader_mobile-brand__veTbd`,
	"rotation": `AppHeader_rotation__+zgNE`
};
export default ___CSS_LOADER_EXPORT___;
